import styled from 'styled-components';

const FlexBox = styled.div.attrs({ className: 'with-ruler' })`
  background-image: ${props => props.bg && `url(${props.bg})`};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  position: relative;
`;

export default FlexBox;
